import * as React from "react";
import { singleton } from "logic/singleton";
const DataLakeFieldsContext = React.createContext(void 0);
export default singleton("contexts.DataLakeFields", () => DataLakeFieldsContext);
